import { loadJSView, loadReactView } from './loadView';

// JS Views
const customerRegistration = loadJSView('front_end/customerRegistration');
const invoicePayment = loadJSView('front_end/invoicePayment');
const newOrderReview = loadJSView('front_end/newOrderReview');
const emailLinkCaptcha = loadJSView('front_end/emailLinkCaptcha');

// React Views
const supplierRegistration = loadReactView('suppliers/registration');

const frontEndViews = {
  customerRegistration,
  invoicePayment,
  newOrderReview,
  emailLinkCaptcha,

  supplierRegistration,
};

export default frontEndViews;
